import request from '@/config/axios'

/** 获取景区概况统计 */
export const getOverviewStats = () => request.get({ url: '/scenic/overview/stats' })

/** 获取移动端入口卡片配置 */
export const getMobileCard = () => request.get({ url: '/scenic/overview/mobile-card' })

/** 保存移动端入口卡片配置 */
export const saveMobileCard = (data: any) => request.post({ url: '/scenic/overview/mobile-card/save', data })

/** 获取PC端入口卡片配置 */
export const getPcCard = () => request.get({ url: '/scenic/overview/pc-card' })

/** 保存PC端入口卡片配置 */
export const savePcCard = (data: any) => request.post({ url: '/scenic/overview/pc-card/save', data })
